import { CategoryNaturalKey } from './../../../../../documents/models/category';
import { ChangeDetectionStrategy, Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StandardTitlesStorage } from '../../../../shared/standard-titles-storage';
import { Subscription } from 'rxjs';

@Component({
    selector: 'document-title',
    template: `<covance-textfield 
        [label]="label" 
        [suggestions]="standardTitles"
        [isLoadingSuggestions]="isLoadingStandardTitles"
        [control]="control" 
        [isRequired]="isRequired"
        [maxBytesCount]="maxBytesCount">
    </covance-textfield>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentTitleComponent implements OnInit, OnDestroy {
    @Input()
    public control: FormControl;

    @Input()
    public isRequired = true;

    @Input()
    public categoryId: CategoryNaturalKey;

    public label = 'Title';
    public maxBytesCount = 75;
    public standardTitles: string[];
    public isLoadingStandardTitles = true;

    private subscription = new Subscription();

    constructor(private standardTitlesStorage: StandardTitlesStorage, private ref: ChangeDetectorRef) { }

    public ngOnInit() {
        this.subscription.add(
            this.standardTitlesStorage.getStandardTitles(this.categoryId)
                .subscribe(titles => {
                    this.standardTitles = titles;
                    this.isLoadingStandardTitles = false;
                    this.ref.markForCheck();
                })
        );
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
